import { RUN_STAGES, RUN_STATUSES } from '@services/fmdc';
import { formatStage } from './format';

export const STAGE_STATES = { DONE: 'done', ACTIVE: 'active', PENDING: 'pending', FAILED: 'failed' };

// The stepper's state per stage, from a run's status and stage_timings. Pure, so a test can pin
// every status without rendering.
//
// - A finished run (review / loadable) has every stage done.
// - A running run has the stages before its status done, its status active, the rest pending.
// - An errored run has the stages with a timing done and the first without one failed; with no
//   timings at all, ingestion itself failed.
export const stageModel = (run) => {
  const status = run?.status;
  const timings = run?.stage_timings || {};
  const finished = status === RUN_STATUSES.REVIEW || status === RUN_STATUSES.LOADABLE;
  const errored = status === RUN_STATUSES.ERROR;
  const activeIndex = RUN_STAGES.indexOf(status);
  const hasTiming = (stage) => timings[stage] !== undefined && timings[stage] !== null;
  const firstWithoutTiming = RUN_STAGES.findIndex((stage) => !hasTiming(stage));

  return RUN_STAGES.map((stage, index) => {
    let state = STAGE_STATES.PENDING;
    if (finished) {
      state = STAGE_STATES.DONE;
    } else if (errored) {
      if (firstWithoutTiming === -1) state = index === RUN_STAGES.length - 1 ? STAGE_STATES.FAILED : STAGE_STATES.DONE;
      else if (index < firstWithoutTiming) state = STAGE_STATES.DONE;
      else if (index === firstWithoutTiming) state = STAGE_STATES.FAILED;
    } else if (activeIndex >= 0) {
      if (index < activeIndex) state = STAGE_STATES.DONE;
      else if (index === activeIndex) state = STAGE_STATES.ACTIVE;
    }
    return { key: stage, label: formatStage(stage), state, seconds: hasTiming(stage) ? Number(timings[stage]) : null };
  });
};
